import { render } from "./IncomeExpenseChart.vue?vue&type=template&id=ade3fda8&scoped=true&ts=true"
import script from "./IncomeExpenseChart.vue?vue&type=script&lang=ts"
export * from "./IncomeExpenseChart.vue?vue&type=script&lang=ts"

import "./IncomeExpenseChart.vue?vue&type=style&index=0&id=ade3fda8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade3fda8"]])

export default __exports__